export default __webpack_public_path__ + "static/media/vip-icon.79c246c1.webp";